module.exports = __webpack_public_path__ + "static/vmware_1.102e7da1.png";